import { Box, Stack, Table, Text } from "@mantine/core";
import { CircleFlag } from "react-circle-flags";
import { Member } from "../../common/members/member.schema";
import { getShowClubs, getShowCountries } from "../../common/util";
import Hider from "../common/Hider";
import MemberDisplay from "./MemberDisplay";

const MemberTable = ({
  members,
  link,
}: {
  members: Member[];
  link?: boolean;
}) => {
  const showClubs = getShowClubs(members);
  const showCountries = getShowCountries(members);
  return (
    <Table fz="xs">
      <Table.Thead>
        <Table.Tr>
          <Table.Th>Name</Table.Th>
          {showClubs && (
            <Hider smallerThan="sm">
              <Table.Th>
                <Box>Club</Box>
              </Table.Th>
            </Hider>
          )}
          {showCountries && (
            <Table.Th>
              <Hider smallerThan="xs">
                <Box>Country</Box>
              </Hider>
            </Table.Th>
          )}
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {members.map((member) => {
          return (
            <Table.Tr key={member._id} style={{ pageBreakInside: "avoid" }}>
              <Table.Td>
                <Stack gap={5}>
                  <MemberDisplay size="sm" member={member} avatar link={link} />
                  <Hider largerThan="sm">
                    <Box ml={42}>
                      <Text size="xs">{member.club}</Text>
                    </Box>
                  </Hider>
                </Stack>
              </Table.Td>
              {showClubs && (
                <Hider smallerThan="sm">
                  <Table.Td>{member.club}</Table.Td>
                </Hider>
              )}
              {showCountries && (
                <Table.Td>
                  {member.country && (
                    <CircleFlag
                      countryCode={member.country.toLowerCase()}
                      height={20}
                    />
                  )}
                </Table.Td>
              )}
            </Table.Tr>
          );
        })}
      </Table.Tbody>
    </Table>
  );
};
export default MemberTable;
